import { __assign, __rest } from "tslib";
import React from 'react';
import { colors } from '@marvelapp/theme';
import Link from './Link';
import { hexToRGB } from './utils';
export default function UserTag(_a) {
    var _b = _a.prefix, prefix = _b === void 0 ? '@' : _b, children = _a.children, props = __rest(_a, ["prefix", "children"]);
    return (React.createElement(Link, __assign({ bg: hexToRGB(colors.marvelExtraLight, 0.3), borderRadius: "1px", color: "marvelDark", display: "inline-block", fontSize: 2, fontWeight: 500, hoverBg: hexToRGB(colors.marvelExtraLight, 0.5), hoverColor: "marvelDark", px: 1 }, props),
        prefix,
        children));
}
